/**
 * React context for workflow variables.
 *
 * Provides discovered workflow variables to deeply nested components
 * (e.g. MacroTypeahead) without prop drilling.
 *
 * @module FlowDesigner/context/WorkflowVariablesContext
 */

import { createContext, useContext } from 'react';
import type { WorkflowVariable } from '../hooks/useWorkflowVariables';

const WorkflowVariablesContext = createContext<WorkflowVariable[]>([]);

export const WorkflowVariablesProvider = WorkflowVariablesContext.Provider;

export function useWorkflowVariablesContext(): WorkflowVariable[] {
  return useContext(WorkflowVariablesContext);
}
